<div edsGrid>
  <!-- add condition based on site  -->
  <div *ngIf="tableData?.annualData" edsRow edsSpacing="md">
    <div edsCol class="table-wrapper">
      <!-- Table for desktop view -->
      <table class="table" *ngIf="(isHandheld$ | async) === false">
        <thead class="table__thead table-head">
          <tr class="table__tr">
            <th class="table__th">
              {{ shareClass }}
            </th>
            <th class="table__th">{{ "products.month-jan" | translate }}</th>
            <th class="table__th">{{ "products.month-feb" | translate }}</th>
            <th class="table__th">{{ "products.month-mar" | translate }}</th>
            <th class="table__th">{{ "products.month-apr" | translate }}</th>
            <th class="table__th">{{ "products.month-may" | translate }}</th>
            <th class="table__th">{{ "products.month-jun" | translate }}</th>
            <th class="table__th">{{ "products.month-jul" | translate }}</th>
            <th class="table__th">{{ "products.month-aug" | translate }}</th>
            <th class="table__th">{{ "products.month-sep" | translate }}</th>
            <th class="table__th">{{ "products.month-oct" | translate }}</th>
            <th class="table__th">{{ "products.month-nov" | translate }}</th>
            <th class="table__th">{{ "products.month-dec" | translate }}</th>
            <th class="table__th">{{ "products.yearToDate" | translate }}</th>
          </tr>
        </thead>

        <tbody class="table__body table-body">
          <tr class="table__tr" *ngFor="let item of tableData?.annualData">
            <td class="table__td">
              {{ item.year }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[0].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[1].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[2].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[3].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[4].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[5].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[6].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[7].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[8].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[9].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[10].returns }}
            </td>
            <td class="table__td">
              {{ item.monthlyReturns[11].returns }}
            </td>
            <td class="table__td">
              {{ item.ytd }}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- cards for mobile view -->
      <div class="cards-mobile" *ngIf="isHandheld$ | async">
        <div *ngFor="let singleYearData of tableData?.annualData">
          <eds-panel
            edsSpacing="xl"
            [hasBorders]="true"
            [hasBorderRadius]="true"
            [overflowHidden]="true"
            [hasPadding]="true"
            [theme]="'white'"
            *ngIf="singleYearData?.cards"
          >
            <div *ngFor="let item of singleYearData?.cards">
              <eds-info-item [info]="item" *ngIf="item"> </eds-info-item>
            </div>
          </eds-panel>
        </div>
      </div>

      <!-- pagination component -->
      <div edsRow *ngIf="totalPages > 1">
        <div edsCol>
          <eds-pagination
            [pages]="totalPages"
            (pageChanged)="onPageChanged($event)"
            [prevPageText]="'products.previous' | translate"
            [nextPageText]="'products.next' | translate"
            [ariaLabelGoToPage]="'products?.ariaLabelGoToPage' | translate"
          ></eds-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
